import './index.scss'
import { useState } from 'react'

import { NavLink } from 'react-router-dom'
import React from 'react'

const Sidebar = () => {
  const [showNav, setShowNav] = useState(false)

  return (
    <div className="nav-top-parent">
      <div className="buttons">
        <NavLink
          // @ts-ignore
          activeclassname="active"
          className="home-link"
          to="/"
          onClick={() => setShowNav(false)}
          style={({ isActive }) => ({
            color: isActive ? '#4D4C49' : '#B2AFA4',
            textDecoration: 'none',
            fontWeight: '600px',
            fontSize: '14px',
            borderBottom: isActive ? '2px solid #4D4C49' : 'none',
            fontFamily: 'Montserrat-SemiBold',
          })}
        >
          HOME
        </NavLink>

        <NavLink
          // @ts-ignore
          activeclassname="active"
          className="projects-link"
          to="/projects"
          onClick={() => setShowNav(false)}
          style={({ isActive }) => ({
            color: isActive ? '#4D4C49' : '#B2AFA4',
            textDecoration: 'none',
            fontWeight: '600px',
            fontSize: '14px',
            borderBottom: isActive ? '2px solid #4D4C49' : 'none',
            fontFamily: 'Montserrat-SemiBold',
          })}
        >
          PROJECTS
        </NavLink>
        <NavLink
          // @ts-ignore
          activeclassname="active"
          className="about-link"
          to="/about"
          onClick={() => setShowNav(false)}
          style={({ isActive }) => ({
            color: isActive ? '#4D4C49' : '#B2AFA4',
            textDecoration: 'none',
            fontWeight: '600px',
            fontSize: '14px',
            borderBottom: isActive ? '2px solid #4D4C49' : 'none',
            fontFamily: 'Montserrat-SemiBold',
          })}
        >
          ABOUT
        </NavLink>
      </div>
    </div>
  )
}

export default Sidebar
